"use client";
import React from "react";
import { MagazinGridOptionsType } from "@/types/ModuleOptionsType";
import {
  Grid,
  GridContent,
  GridItem,
  GridLoadMore,
} from "@aleksundshantu/aunds-utils-react/primitives/grid";

import {
  MagazineCard,
  MagazineCardElement,
} from "@/components/MagazineCard/MagazineCard";
import { ImageType } from "@/types/baseTypes";
import buttonStyles from "../../components/Button/Button.module.scss";
import { fetchMagazin } from "@/getData/fetchMagazin";
import { mockMagazine } from "@/ui/mock-data";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { MagazinGridModuleType } from "./MagazinGrid.server";

interface QuoteGridProps {
  data: MagazinGridModuleType;
  magazinGridOptionsType: {
    box: MagazinGridOptionsType["box"];
    grid_options: {
      grid_navigation: MagazinGridOptionsType["grid_options"]["grid_navigation"];
    };
  };
  fallbackImage: ImageType | false | undefined;
  cardHeadlineLevel: number;
  initialPosts: MagazineCardElement[];
  initialTotalPosts: number;
}
{
  /* jscpd:ignore-start */
}
const MagazinGridClient = ({
  data,
  magazinGridOptionsType,
  fallbackImage,
  cardHeadlineLevel,
  initialPosts,
  initialTotalPosts,
}: QuoteGridProps) => {
  const { posts_per_page } = data.layout;

  const { locale } = useGlobalContext();
  const {
    box: { show_border_radius, show_box_shadow, show_card_box },
    grid_options: { grid_navigation },
  } = magazinGridOptionsType || {};

  return (
    <Grid
      postsPerPage={posts_per_page}
      initialItems={initialPosts}
      initialTotalPosts={initialTotalPosts}
      fetchItems={({ page, postsPerPage, offset }) => {
        return fetchMagazin({
          page,
          postsPerPage,
          offset,
          locale,
          module: data,
        });
      }}
      renderLoading
    >
      {(gridPosts, loading) => {
        return (
          <>
            <GridContent justifyContent="center" gap="2rem">
              {gridPosts.map((element, key) => {
                return (
                  <GridItem
                    itemWidth={{
                      mobile: "100%",
                      widescreen: "50%",
                    }}
                    key={key}
                  >
                    <MagazineCard
                      skeleton={loading}
                      element={
                        loading
                          ? mockMagazine
                          : (element as MagazineCardElement)
                      }
                      show_border_radius={show_border_radius}
                      show_box_shadow={show_box_shadow}
                      showBox={show_card_box}
                      fallbackImage={fallbackImage}
                      heading_level={cardHeadlineLevel}
                    />
                  </GridItem>
                );
              })}
            </GridContent>
            <GridLoadMore
              grid_navigation={grid_navigation}
              buttonStyles={buttonStyles}
              iconPosition="left"
            />
          </>
        );
      }}
    </Grid>
  );
};
{
  /* jscpd:ignore-end */
}
export default MagazinGridClient;
